var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27275 15.1685C12.5655 15.1685 16.0455 11.814 16.0455 7.67604C16.0455 3.53808 12.5655 0.183594 8.27275 0.183594C3.97998 0.183594 0.5 3.53808 0.5 7.67604C0.5 11.814 3.97998 15.1685 8.27275 15.1685ZM8.26314 13.0283C11.3294 13.0283 13.8151 10.6323 13.8151 7.67657C13.8151 4.72088 11.3294 2.32482 8.26314 2.32482C5.19687 2.32482 2.71117 4.72088 2.71117 7.67657C2.71117 10.6323 5.19687 13.0283 8.26314 13.0283Z",
    fill: "#302B3A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.07465,
    height: 7.99534,
    rx: 1.03732,
    transform: "matrix(0.771051 -0.636773 0.664326 0.747443 11.5888 12.208)",
    fill: "#302B3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.445f433f2c31e3af392fa81ac585bb60.svg";
export { ForwardRef as ReactComponent };